import React, { useEffect } from 'react';
import { LandingPage } from './pages/LandingPage';
import { PanelExpertsPage } from './pages/PanelExpertsPage';
import { ExpertDetailPage } from './pages/ExpertDetailPage';
import { ContactPage } from './pages/ContactPage';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsConditions } from './pages/TermsConditions';
import { CancellationPolicy } from './pages/CancellationPolicy';
import { FAQPage } from './pages/FAQPage';
import { PersonalInjuryService } from './pages/PersonalInjuryService';
import { ClinicalNegligenceService } from './pages/ClinicalNegligenceService';
import { ImmigrationService } from './pages/ImmigrationService';
import { FamilyCourtService } from './pages/FamilyCourtService';
import { IndustrialDiseaseService } from './pages/IndustrialDiseaseService';
import { CriminalCasesService } from './pages/CriminalCasesService';
import { AboutPage } from './pages/AboutPage';
import { experts } from './components/expertsData';
export function App() {
  useEffect(() => {
    const handleHashChange = () => {
      window.scrollTo(0, 0);
    };
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);
  const path = window.location.pathname;
  // Service pages
  if (path === '/services/personal-injury') return <PersonalInjuryService data-id="element-0" />;
  if (path === '/services/clinical-negligence') return <ClinicalNegligenceService data-id="element-1" />;
  if (path === '/services/immigration') return <ImmigrationService data-id="element-2" />;
  if (path === '/services/family-court') return <FamilyCourtService data-id="element-3" />;
  if (path === '/services/industrial-disease') return <IndustrialDiseaseService data-id="element-4" />;
  if (path === '/services/criminal-cases') return <CriminalCasesService data-id="element-5" />;
  // Expert Detail Page — slug-based SEO URLs
  if (path.startsWith('/experts/')) {
    const slug = path.split('/')[2];
    const expert = experts.find(e => e.slug === slug);
    if (expert) return <ExpertDetailPage expert={expert} data-id="element-6" />;
    return <PanelExpertsPage data-id="element-7" />;
  }
  // Expert Detail Page — legacy ID-based URLs (backwards compatible)
  if (path.startsWith('/panel-experts/')) {
    const id = path.split('/')[2];
    const expert = experts.find(e => e.id === id);
    if (expert) return <ExpertDetailPage expert={expert} data-id="element-8" />;
    return <PanelExpertsPage data-id="element-9" />;
  }
  // Main pages
  if (path === '/about') return <AboutPage data-id="element-10" />;
  if (path === '/panel-experts') return <PanelExpertsPage data-id="element-11" />;
  if (path === '/contact') return <ContactPage data-id="element-12" />;
  if (path === '/faq') return <FAQPage data-id="element-13" />;
  // Legal pages
  if (path === '/privacy-policy') return <PrivacyPolicy data-id="element-14" />;
  if (path === '/terms-conditions') return <TermsConditions data-id="element-15" />;
  if (path === '/cancellation-policy') return <CancellationPolicy data-id="element-16" />;
  // Default
  return <LandingPage data-id="element-17" />;
}